import { Col, Container, Row, Stack } from "react-bootstrap"

const HirePhpDeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Expert PHP Developers for Scalable Web Solutions
                        </h2>
                        <p>
                            Looking to build fast, secure, and feature-rich web applications? Hire our dedicated PHP developers who combine technical expertise with industry experience to deliver high-performance, custom PHP solutions tailored to your business needs.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire PHP Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>Extensive PHP Experience</b>
                                <p>
                                    Our developers have deep expertise in Core PHP and modern frameworks like Laravel, CodeIgniter, and Symfony, allowing them to build everything from lightweight websites to complex enterprise platforms.
                                </p>
                            </li>
                            <li>
                                <b>Secure & Scalable Architecture</b>
                                <p>
                                    We follow best practices for application security, performance optimization, and scalable backend design to ensure your app runs smoothly under any load.
                                </p>
                            </li>
                            <li>
                                <b>Custom Web Application Development</b>
                                <p>
                                    We specialize in creating scalable and secure PHP-based web applications with clean architecture, intuitive UI/UX, and high code quality.
                                </p>
                            </li>
                            <li>
                                <b>eCommerce Development</b>
                                <p>
                                    Build powerful eCommerce platforms using Magento, WooCommerce, or custom PHP development — complete with payment integration, product management, and order tracking systems.
                                </p>
                            </li>
                            <li>
                                <b>CMS Development & Customization</b>
                                <p>
                                    Get dynamic websites built on popular PHP-based CMS platforms like WordPress, Drupal, or Joomla — customized to reflect your brand and business goals.
                                </p>
                            </li>
                            <li>
                                <b>API Integration & Development</b>
                                <p>
                                    We build RESTful APIs and integrate third-party APIs for seamless interaction with CRMs, ERPs, payment gateways, and other services.
                                </p>
                            </li>
                            <li>
                                <b>Legacy System Modernization</b>
                                <p>
                                    Upgrade old PHP systems to modern, secure, and scalable platforms with optimized performance and improved functionality.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Models</b>
                                <p>
                                    Choose from part-time, full-time, or hourly PHP developers based on your project size, timeline, and budget.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our PHP Development Services Include:</h2>
                        <ul>
                            <li>Custom PHP Web Application Development</li>
                            <li>Laravel/CodeIgniter Development</li>
                            <li>WordPress & WooCommerce Development</li>
                            <li>API Development & Integration</li>
                            <li>eCommerce Website Development</li>
                            <li>CMS Development & Maintenance</li>
                            <li>Legacy App Migration & Modernization</li>
                            <li>Ongoing Support & Optimization</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Kickstart Your PHP Project with Confidence
                        </h2>
                        <p>
                            Our skilled PHP developers combine technical expertise with a deep understanding of business needs to deliver secure, high-performance web solutions. Whether you're starting from scratch or enhancing an existing application, we’re here to help. Contact us today for a free consultation and personalized quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HirePhpDeveloperContent;
